/**
 * Rastreio de interação do usuário para o heartbeat de presença.
 *
 * Alimenta o SocketWorker com o tempo de inatividade (idleMs) enviado ao
 * backend, que decide online (ativo) vs away (aba aberta, >= 5 min parado).
 * Listeners passivos com throttle de 5s — custo desprezível por interação.
 */

const INTERACTION_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'];
const WRITE_THROTTLE_MS = 5000;
/** Deve espelhar AWAY_THRESHOLD_MS do backend (libs/presence.ts). */
export const AWAY_THRESHOLD_MS = 5 * 60 * 1000;

let lastInteractionAt = Date.now();
let tracking = false;
let becameActiveCallbacks = [];

const handleInteraction = () => {
  const now = Date.now();
  if (now - lastInteractionAt < WRITE_THROTTLE_MS) return;
  const wasIdle = now - lastInteractionAt >= AWAY_THRESHOLD_MS;
  lastInteractionAt = now;
  if (wasIdle) {
    becameActiveCallbacks.forEach((cb) => {
      try {
        cb();
      } catch {
        // listener não pode quebrar o tracking
      }
    });
  }
};

export function startTracking() {
  if (tracking) return;
  tracking = true;
  lastInteractionAt = Date.now();
  INTERACTION_EVENTS.forEach((event) => {
    window.addEventListener(event, handleInteraction, { passive: true });
  });
}

export function stopTracking() {
  if (!tracking) return;
  tracking = false;
  INTERACTION_EVENTS.forEach((event) => {
    window.removeEventListener(event, handleInteraction);
  });
}

export function getIdleMs() {
  return Date.now() - lastInteractionAt;
}

/**
 * Registra callback disparado quando o usuário volta a interagir após ficar
 * ausente (idle >= threshold) — usado para heartbeat imediato away→online.
 * Retorna função de unsubscribe.
 */
export function onBecameActive(callback) {
  becameActiveCallbacks.push(callback);
  return () => {
    becameActiveCallbacks = becameActiveCallbacks.filter((cb) => cb !== callback);
  };
}
